import {createRoot, hydrateRoot} from 'react-dom/client';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy'
import "../index.css";
import "../pages/PrivacyPolicy/PrivacyPolicy.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<PrivacyPolicy {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <PrivacyPolicy {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).PrivacyPolicyVC = {mount, hydrate, unmount}